import React from 'react';

import { Switch, Route } from 'react-router-dom';

import loadable from '@loadable/component';
import { AgencyGuard } from 'guards';
import { Assessment, Settings } from '@mui/icons-material';

export const routesAgency = [
  {
    exact: true,
    path: '/agency/reports/',
    guard: AgencyGuard,
    isSidebar: true,
    name: 'Relatórios',
    icon: Assessment,
    component: loadable(() => import('modules/agency/screens/Reports')),
  },
  {
    exact: true,
    path: '/agency/new_reports/',
    guard: AgencyGuard,
    isSidebar: true,
    name: 'Caixa',
    icon: Assessment,
    component: loadable(() => import('modules/agency/screens/Reports/newReport')),
  },
  {
    exact: false,
    path: '/agency/tickets/',
    guard: AgencyGuard,
    isSidebar: true,
    name: 'Tickets',
    icon: Assessment,
    component: loadable(() => import('modules/agency/screens/Tickets')),
  },
  {
    exact: true,
    path: '/agency/payments/',
    guard: AgencyGuard,
    isSidebar: true,
    name: 'Payments',
    icon: Assessment,
    component: loadable(() => import('modules/agency/screens/Payments')),
  },
  {
    exact: true,
    path: '/agency/settings/',
    guard: AgencyGuard,
    isSidebar: true,
    name: 'Settings',
    icon: Settings,
    component: loadable(() => import('modules/agency/screens/Settings')),
  },
];

const Router = () => {
  return (
    <Switch>
      {routesAgency.map((item) => (
        <Route path={item.path} exact={item.exact} component={item.component} />
      ))}
    </Switch>
  );
};

export default Router;
